export default __webpack_public_path__ + "static/media/riot.62585593.svg";